/**
 * StepIndicator Component
 *
 * Visual progress indicator for multi-step flows in FORGE Detailed Mode
 * Shows current step, completed steps, and pending steps
 */

import React from 'react';
import styles from '../styles/forge.module.css';

interface StepIndicatorProps {
  currentStep: number;
  steps: string[];
  onStepClick?: (index: number) => void;
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep,
  steps,
  onStepClick,
}) => {
  return (
    <div className={styles.forgeProgress}>
      {steps.map((label, index) => (
        <React.Fragment key={label}>
          <div
            className={`${styles.forgeProgressStep} ${
              index <= currentStep ? styles.forgeProgressStepActive : ''
            } ${index < currentStep ? styles.forgeProgressStepCompleted : ''}`}
            onClick={() => onStepClick && onStepClick(index)}
            role="button"
            tabIndex={onStepClick ? 0 : -1}
            aria-current={index === currentStep ? 'step' : undefined}
          >
            <span className={styles.forgeProgressStepNumber}>{index + 1}</span>
            <span className={styles.forgeProgressStepLabel}>{label}</span>
          </div>
          {index < steps.length - 1 && (
            <div
              className={`${styles.forgeProgressLine} ${
                index < currentStep ? styles.forgeProgressLineCompleted : ''
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StepIndicator;
